import React, { FC } from 'react';
import { MotifFormField, MotifLabel, MotifDatePicker } from '@ey-xd/motif-react';
import { ErrorMessage } from 'common/components';
import './DatePicker.scss';

type DatePickerProps = {
    id?: string;
    name?: string;
    label?: string;
    value?: Date | [Date];
    errorMessage?: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    format?: string;
    maxDate?: Date;
    minDate?: Date;
    showLeadingZeros?: boolean;
    yearPlaceholder?: string;
    dayPlaceholder?: string;
    monthPlaceholder?: string;
    onChange: (date: Date) => void;
    onFocus?: (event: any) => void;
    onClick?: (event: any) => void;
    onCalendarOpen?: (event: any) => void;
    onCalendarClose?: (event: any) => void;
    onKeyDown?: (event: any) => void;
    clearIcon?: any;
};
const DatePicker: FC<DatePickerProps> = ({
    id,
    name,
    label,
    value,
    errorMessage,
    required,
    disabled,
    className,
    format = 'MM-dd-yyyy',
    maxDate,
    minDate,
    showLeadingZeros,
    yearPlaceholder,
    dayPlaceholder,
    monthPlaceholder,
    onChange,
    onClick,
    onCalendarClose,
    onCalendarOpen,
    onFocus,
    onKeyDown,
    clearIcon = ''
}: DatePickerProps) => {
    return (
        <MotifFormField className="motif-form-field-text-input">
            {label && <MotifLabel>{label}</MotifLabel>}
            <MotifDatePicker
                id={id}
                name={name}
                value={value}
                className={`date-picker ${value ? 'date-picker--has-value' : ''} ${className}`}
                required={required}
                format={format}
                clearIcon={clearIcon}
                showLeadingZeros={showLeadingZeros}
                onChange={onChange}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                onClick={onClick}
                onCalendarOpen={onCalendarOpen}
                onCalendarClose={onCalendarClose}
                yearPlaceholder={yearPlaceholder}
                dayPlaceholder={dayPlaceholder}
                monthPlaceholder={monthPlaceholder}
                disabled={disabled}
                minDate={minDate}
                maxDate={maxDate}
            />
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </MotifFormField>
    );
};

export default DatePicker;
